export default function menuAnchorHandler() {
  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      const anchorLink = e.target.closest('a[data-anchor="home_text_image"]');
      if (anchorLink) {
        const isHome = document.body.classList.contains('template-index');
        const anchor = '#home_text_image';
        if (isHome) {
          e.preventDefault();
          const target = document.querySelector(anchor);
          if (target) {
            const offset = window.innerWidth <= 991 ? 80 : 130;
            window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
          }
        } else {
          sessionStorage.setItem('scrollToHomeTextImage', '1');
          // Let the link navigate as normal
        }
      }
    });
    // On homepage load, check for scroll intent
    if (document.body.classList.contains('template-index') && sessionStorage.getItem('scrollToHomeTextImage') === '1') {
      const target = document.getElementById('home_text_image');
      if (target) {
        const offset = window.innerWidth <= 991 ? 80 : 130;
        window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
      }
      sessionStorage.removeItem('scrollToHomeTextImage');
    }
  });
}
